import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchAllAssignedRooms = createAsyncThunk(
    'assigneProjectRooms/fetchAllAssignedRooms',
    async (clientUID)=>{
        console.log("clientUID",clientUID);
        
        
        const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/fetch-assigne-room-to/${clientUID}/rooms`);
        return response.data;
    }
) 

const AssignedProjectViewReducer = createSlice({
    name:'assigneProjectRooms',
    initialState:{
        allAssigneRoomData:{clients:[]},
        viewLoader: true,
        error:null,
    },
    reducers:{},
    extraReducers: (builder)=>{
        builder
        .addCase(fetchAllAssignedRooms.pending, (state)=>{
            state.viewLoader=true;
            state.viewError = null;
        })
        .addCase(fetchAllAssignedRooms.fulfilled,(state,action)=>{
            state.viewLoader = false;
            state.allAssigneRoomData = action.payload;
        })
        .addCase(fetchAllAssignedRooms.rejected,(state ,action)=>{
           state.viewLoader = false;
           state.viewError = action.error.message;
        })
    }
})

export default AssignedProjectViewReducer.reducer